/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { createDialogRoute, FormState, FormStateBuilder } from '@gh/common-shared';
import { AutocompleteLoadMoreEvent, DialogInput } from '@gh/core-ui';
import { JobCsCreateBusinessService, JobCsInit } from '../../resources';
import { ID } from '@gh/common-shared-data';

export interface JobCsCreateDialogConfig {
  isFromCreateBtn: boolean;
  jobId?: ID;
}

@Component({
  selector: 'gh-job-cs-create-dialog',
  template: require('./job-cs-create-dialog.component.html'),
  styles: [require('./job-cs-create-dialog.component.scss')],
})
export class JobCsCreateDialogComponent implements OnInit, DialogInput<JobCsCreateDialogConfig> {
  input: JobCsCreateDialogConfig;
  form: FormState<JobCsInit>;

  constructor(private business: JobCsCreateBusinessService,
              private formStateBuilder: FormStateBuilder,
              private dialogRef: MatDialogRef<any>) {

  }

  ngOnInit(): void {
    this.form = this.formStateBuilder.buildPlain({
      value: {
        jobId: this.input.jobId,
      },
      children: {
        jobId: { visible: this.input.isFromCreateBtn, required: true },
        master: { required: true },
      },
    });
  }

  get title(): string {
    return this.input.isFromCreateBtn ? 'lbl_create_job_cs' : 'lbl_select_color_selection_master';
  }

  loadMoreMasters(event: AutocompleteLoadMoreEvent): void {
    event.load(this.business.findCsMastersByName(event.query));
  }

  onApply(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.dialogRef.close(this.form.group.value);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  loadJobs(event: AutocompleteLoadMoreEvent): void {
    event.load(this.business.findAllJobs(event.query));
  }
}

export const jobCsCreateDialogRoute = createDialogRoute({
  component: JobCsCreateDialogComponent,
});
